import {DomainStore} from 'shared/store';
import { makeAutoObservable } from 'mobx';
import {endpoints, types} from 'main/tools';
import {ExpensePolicy, ExpensePolicyApprover} from 'main/stores/expenses';
import {User} from 'main/stores/users';

const STEP_CONFIG = {
  policy_details: {fields: ['name'], endpoint: endpoints.EXPENSES.POLICIES.UPDATE_DETAILS},
  employees: {fields: ['employees'], endpoint: endpoints.EXPENSES.POLICIES.UPDATE_EMPLOYEES},
  approvers: {fields: ['approvers'], endpoint: endpoints.EXPENSES.POLICIES.UPDATE_APPROVERS}
};

class PolicyEditFlowState {
  store = new DomainStore();
  match;
  history;

  policy;
  errors = {};

  constructor() {
    makeAutoObservable(this, {
      store: false,
      history: false
    });
  }

  receiveProps({match, history}) {
    this.match = match;
    this.history = history;
  }

  async load() {
    await this.store._compose([
      endpoints.EXPENSES.POLICIES.with(this.match.params.id),
      endpoints.USERS.ACTIVE
    ]);

    this.policy = new ExpensePolicy(this.store._getSingle(types.EXPENSES.POLICY));
  }

  async onStepSubmitted({location}) {
    if (location === 'review') {
      this.history.push('/manage');
      return;
    }

    return this.submitStep(location);
  }

  async onStepChanged() {}

  async submitStep(location) {
    const {fields, endpoint} = STEP_CONFIG[location];
    const policy = this.policy.pick(fields);
    const {model, errors} = await this.store.patch(
      endpoint.with(this.match.params.id),
      types.EXPENSES.POLICY,
      policy
    );

    this.errors = errors;
    if (!model) return false;

    this.policy.update(model);
    return true;
  }

  get availableApprovers() {
    const users = this.store._getAll(types.USER).map(u => new User(u));

    return [
      new ExpensePolicyApprover({approvalType: 'manager'}),
      ...users.map(user => new ExpensePolicyApprover({approvalType: 'specific_user', user}))
    ];
  }
}

export default PolicyEditFlowState;
